/**
 * Formats street address line (unit + street).
 * @example formatStreetLine('Unit 5', '123 Main St') => 'Unit 5, 123 Main St'
 */
export function formatStreetLine(address2?: string, address?: string): string {
  return [address2, address].filter(Boolean).join(', ')
}

/**
 * Formats an autocomplete display address with unit number included in the street line.
 */
export function formatAddressDisplayWithUnit(text: string, unitNumber: string | undefined, street: string): string {
  if (!unitNumber || text.includes(unitNumber)) {
    return text
  }

  const streetWithUnit = `${unitNumber}/${street}`
  if (text.startsWith(street)) {
    return text.replace(street, streetWithUnit)
  }

  return `${streetWithUnit}, ${text}`
}

/**
 * Formats location line (city, state, postcode).
 * @example formatLocationLine('Melbourne', 'VIC', '3000') => 'Melbourne, VIC, 3000'
 */
export function formatLocationLine(city?: string, state?: string, postcode?: string): string {
  return [city, state, postcode].filter(Boolean).join(', ')
}
